import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import imgHANSA_FLEX_BRANCH_SERBIA_NOVISAD from '../../../assets/Journey/HANSA_FLEX_BRANCH_SERBIA_NOVISAD.webp'

import imgCylinder1 from '../../../assets/Branch/Cylinder/Cylinder1.jpg';
import imgCylinder2 from '../../../assets/Branch/Cylinder/Cylinder2.jpg';
import imgCylinder3 from '../../../assets/Branch/Cylinder/Cylinder3.jpg';
import imgCylinder4 from '../../../assets/Branch/Cylinder/Cylinder4.jpg';
import imgCylinder5 from '../../../assets/Branch/Cylinder/Cylinder5.jpg';
import imgCylinder6 from '../../../assets/Branch/Cylinder/Cylinder6.jpg';
import imgCylinder7 from '../../../assets/Branch/Cylinder/Cylinder7.jpg';
import imgNovisad1 from '../../../assets/Branch/Novisad/Novisad1.jpg';
import imgNovisad2 from '../../../assets/Branch/Novisad/Novisad2.jpg';
import imgNovisad3 from '../../../assets/Branch/Novisad/Novisad3.jpg';
import imgNovisad4 from '../../../assets/Branch/Novisad/Novisad4.jpg';
import imgNovisad5 from '../../../assets/Branch/Novisad/Novisad5.jpg';
import imgNovisad6 from '../../../assets/Branch/Novisad/Novisad6.jpg';
import imgNovisad7 from '../../../assets/Branch/Novisad/Novisad7.jpg';


const Branch4 = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

   const carouselData2 = [
        {
            image: imgCylinder1,
        },
        {
            image: imgCylinder2,
        },
        {
            image: imgCylinder3,
        },
        {
            image: imgCylinder4,
        },
        {
            image: imgCylinder5,
        },
        {
            image: imgCylinder6,
        },
        {
            image: imgCylinder7,
        },

    ]

       const carouselData = [
        {
            image: imgNovisad1,
        },
        {
            image: imgNovisad2,
        },
        {
            image: imgNovisad3,
        },
        {
            image: imgNovisad4,
        },
        {
            image: imgNovisad5,
        },
        {
            image: imgNovisad6,
        },
        {
            image: imgNovisad7,
        },

    ]
    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX_BRANCH_SERBIA_NOVISAD} title={"Welcome to HANSA-FLEX Novi Sad"} paragraph={"Founded in 2015, located in the Western part of Novi Sad, Veternik, HANSA-FLEX Novi Sad has quickly attracted the great number of customers, from the large construction companies to the manufacturers of all kind of devices and equipment for agriculture and other purposes, who needed the quality and stability of the supplier such as HANSA-FLEX as their OEM supplier. Beside usual products and services which HANSA-FLEX provides, in the Novi Sad branch you can also do a repair of your hydraulic cylinder.Beside Novi Sad, the branch covers the large region from Inđija and Fruška Gora in the South, to the Croatian, Hungarian and Romanian border on the East side."}
            buttonName={"Contact us"} buttonLink={"/contact-us"}
        />

            <ThreeDImageCarousel items={carouselData2} />
            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>

            <SectionHeader title={""} />
            <ThreeDImageCarousel items={carouselData} />
        </div>
    )
}

export default Branch4